import React from 'react';
import { useLocation } from 'react-router-dom';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import './ComingSoon.scss';

const PAGE_TITLES: Record<string, string> = {
   '/teams': 'Teams',
   '/records': 'School records',
   '/photos': 'Photos',
   '/search': 'Site search',
   '/subscribe': 'Calendar subscriptions',
};

export default function ComingSoon() {
   const location = useLocation();
   const title = PAGE_TITLES[location.pathname] || 'This section';

   return (
      <div className='school-coming-soon'>
         <div className='school-coming-soon__card'>
            <span className='school-coming-soon__icon' aria-hidden='true'>
               <ConstructionRoundedIcon />
            </span>
            <span className='school-coming-soon__eyebrow'>Coming soon</span>
            <h1>{title}</h1>
            <p>We are preparing this part of the school sport site. Existing fixtures, results and calendar pages remain available from the navigation.</p>
         </div>
      </div>
   );
}
